<template>
  <el-dialog
    :title="$t('coHost.assign')"
    :visible.sync="info.show"
    :close-on-click-modal="false"
    width="800px"
    :modal="false"
    @close="closeAdvanced"
  >
    <div class="loading-txt" v-if="cohostScroll.loading">
      <i class="el-icon-loading" style="color: #909090"></i>
      {{ $t("eventList.loading") }}
    </div>
    <div
      class="assignBox"
      v-else-if="hadInviteCohost.length != 0 && !cohostScroll.loading"
    >
      <div class="userListBox">
        <span class="title" v-if="!isEditing">
           Select co-hosts to the event
        </span>
        <el-input
          v-else
          placeholder="Please enter email"
          @input="searchCohost"
          v-model="coHostSearchName"
          clearable
        ></el-input>
        <i class="el-icon-search" @click="toggleEdit"></i>
        <el-checkbox
          v-model="allSelected"
          class="checkbox-circle"
          @change="handleSelectAll"
        />
      </div>
      <el-checkbox-group
        v-model="selectedEmails"
        @change="handleCheckedEmailsChange"
        class="hadInviteList scrollbar"
        v-scroll="cohostScroll"
      >
        <div
          class="li"
          v-for="user in filteredCohosts"
          :key="user.collaborateEmail"
        >
          <span class="firstName" :style="{'background':user.color}">{{
            user.collaborateEmail ? user.collaborateEmail.slice(0, 1) : ""
          }}</span>
          <span class="emailContent" :class="{ declined: user.status === 2 }">{{
            user.collaborateEmail
          }}</span>
          <el-checkbox
            :label="user.collaborateEmail"
            class="right checkbox-circle"
            v-model="selectedEmails"
            @click.native.stop
          ></el-checkbox>
        </div>
      </el-checkbox-group>
      <div class="selectedBox">
        {{ $t('coHost.selected') + ' ' +selectedEmails.length}}
      </div>
    </div>
    <div v-else class="noCoHost">
      <div>
        <span>Click</span>
        <!-- 只在 "+ Add" 部分绑定事件处理器，并添加类以改变颜色 -->
        <span class="add-cohost-action" @click="showAddPop">&nbsp;+Add&nbsp;</span>
        <span> to invite your first co-host.</span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div
        class="enterReceivedCohost"
        @click="showAddPop"
        v-if="hadInviteCohost.length != 0 && !cohostScroll.loading"
      >
        <i class="el-icon-plus" slot="reference"></i>
        <p>{{ $t("coHost.add") }}</p>
      </div>
      <div v-else style="width: 100px"></div>
      <div>
        <div v-if="hadInviteCohost.length != 0 && !cohostScroll.loading">
          <el-button @click="closeAdvanced" class="cancel">Cancel</el-button>
          <el-button @click="assignEmails">Assign</el-button>
        </div>
        <el-button
          v-else-if="hadInviteCohost.length == 0 && !cohostScroll.loading"
          @click="closeAdvanced"
          >Got it</el-button
        >
      </div>
    </span>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import Tools from '@/assets/js/utils'
export default {
  props: {
    coHostEventInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    changeRtmpType: String,
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
    eventInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      State: (state) => state
    })
  },
  watch: {
    selectedEmails: {
      handler (newValue, oldValue) {
        // 检查 oldValue 中的元素是否在 newValue 中
        const deletedEmails = oldValue.filter(email => !newValue.includes(email))
        this.delCollaborateUserEmailList.push(...deletedEmails)
        if (newValue) {
          this.updateSelectAllStatus()
        }
      },
      deep: true
    }
  },
  data () {
    return {
      value: [],
      delCollaborateUserEmailList: [],
      isEditing: false,
      allSelected: false,
      selectedEmails: [],
      cohostPageInfo: {
        pageNum: 1,
        pageSize: 100,
        hasNextPage: false
      },
      coHostSearchName: '',
      cohostScroll: {
        onScroll: this.getCoHostHadInvite,
        loading: false,
        noMore: false,
        directive: '.el-select-dropdown__wrap'
      },
      hadInviteCohost: [],
      filteredCohosts: []
    }
  },
  created () {
    // 打开弹窗后数据加载
    this.getCoHostHadInvite('init')
  },
  methods: {
    toggleEdit () {
      this.isEditing = !this.isEditing
    },
    searchCohost () {
      if (this.coHostSearchName) {
        this.filteredCohosts = this.hadInviteCohost.filter(user =>
          user.collaborateEmail.toLowerCase().includes(this.coHostSearchName.toLowerCase())
        )
      } else {
        this.filteredCohosts = this.hadInviteCohost
      }
    },
    // toggleCheckbox (email) {
    //   const currentIndex = this.selectedEmails.indexOf(email)
    //   if (currentIndex === -1) {
    //   // 如果邮箱不在selectedEmails中, 添加它
    //     this.selectedEmails.push(email)
    //   } else {
    //   // 如果已在列表中，则移除它
    //     this.selectedEmails.splice(currentIndex, 1)
    //   }
    //   this.updateSelectAllStatus() // 更新全选的状态
    // },
    handleCheckedEmailsChange (value) {
      const checkedCount = value.length
      this.allSelected = checkedCount === this.hadInviteCohost.length
    },
    handleSelectAll (val) {
      if (val) {
        this.selectedEmails = this.hadInviteCohost.map(user => user.collaborateEmail)
      } else {
        this.selectedEmails = []
      }
      this.updateSelectAllStatus()
    },
    updateSelectAllStatus () {
      if (this.selectedEmails.length === this.hadInviteCohost.length) {
        this.allSelected = true
      } else if (this.selectedEmails.length > 0) {
        this.allSelected = false
      } else {
        this.allSelected = false
      }
    },
    showAddPop () {
      this.$emit('showAddCoHostPop', this.coHostEventInfo)
      this.info.show = false
    },
    returnColor (info) {
      const { status } = info
      if (status === 0 || status === 2) {
        return 'gray'
      } else if (status === 1) {
        return Tools.getEmailColor(info.collaborateEmail, this.State.avatarColor)
      }
    },
    async getCoHostHadInvite (init) {
      if (!init && !this.cohostPageInfo.hasNextPage) return
      // 如果init没有则是滚动加载进来的页数要加1
      if (!init) this.cohostPageInfo.pageNum++
      this.cohostScroll.loading = true
      // 清空之前的状态
      this.coHostSearchName = ''
      const params = {
        invite: true,
        queryCollaborate: true,
        pageSize: this.cohostPageInfo.pageSize,
        pageNum: this.cohostPageInfo.pageNum,
        status: 1
      }
      await this.$http
        .post('/commentator-backend/collaborate/queryV2', params)
        .then(res => {
          this.cohostScroll.loading = false
          const { errorCode, result } = res.data
          if (errorCode === '0x0') {
            this.cohostPageInfo.hasNextPage = result.hasNextPage
            result.list.forEach((info, index) => {
              info.color = this.returnColor(info)
            })
            if (!init) {
              this.hadInviteCohost = this.hadInviteCohost.concat(result.list)
            } else {
              this.hadInviteCohost = result.list
            }
            this.filteredCohosts = this.hadInviteCohost
            if (this.coHostEventInfo.id && this.coHostEventInfo.coHost.collaborateUserEmailList) {
              this.selectedEmails = this.coHostEventInfo.coHost.collaborateUserEmailList
            } else {
              this.selectedEmails = this.State.hasAssignCoHostEmails
            }
          } else {
            this.$message.warning(res.data.errorInfo)
          }
        })
    },
    // co-host分配
    assignEmails () {
      if (this.selectedEmails.length > this.State.config.coHostInfo.limit) {
        this.$message.warning(this.$t('coHost.supportNumber', { supportNumber: this.State.config.coHostInfo.limit }))
        return
      }
      this.State.assignCoHostEmails = []
      this.State.assignEmailNames = []
      this.State.hasAssignCoHostEmails = this.selectedEmails
      // 首先只处理 collaboratorUserEmailList 中的前四个邮件
      const emailList = this.selectedEmails.slice(0, 3)
      // 确保emailList为数组，然后添加this.State.loginInfo.email到数组末尾
      emailList.push(this.State.loginInfo.email)
      // 如果需要继续处理emailList，比如获取每个邮件的首字母形成新的数组
      this.State.assignCoHostEmails = emailList.map(email => {
        const namePart = email.split('@')[0]
        this.State.assignEmailNames.push(namePart)
        const color = email === this.State.loginInfo.email ? this.State.avatarColor : Tools.getEmailColor(email, this.State.avatarColor);
        return {
          email: email.slice(0, 1),
          color: color
        }
      })
      this.closeAdvanced()
      this.$emit('assignEmails', this.selectedEmails)
      if (this.coHostEventInfo.id && this.coHostEventInfo.collaborateType != '2') {
        // 直接分配
        const params = {
          eventId: this.coHostEventInfo.id,
          collaborateUserEmailList: this.selectedEmails,
          delCollaborateUserEmailList: this.delCollaborateUserEmailList
        }
        if (this.coHostEventInfo.platform == 1) {
          delete params.delCollaborateUserEmailList
        }
        this.$http
          .post('/commentator-backend/collaborate/update', params)
          .then(res => {
            if (res.data.errorCode === '0x0') {
              this.$message.success(this.$t('coHost.assignSuccess'))
            }
          })
      }
    },
    // 保存数据关闭弹窗
    closeAdvanced () {
      this.info.show = false
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-dialog {
  border-radius: 8px;
  .el-dialog__header {
    .el-dialog__headerbtn {
      z-index: 1;
      .el-dialog__close {
        font-size: 16px;
        color: #28282e;
        font-weight: bold;
      }
      &:hover .el-dialog__close {
        color: #33ab4f;
      }
    }
  }
  .el-dialog__body {
    border-top: 2px solid #f5f5f5;
    margin: 0px 18px 24px 18px !important;
    padding: 0px !important;
    .noCoHost > div {
      display: flex;
      align-items: center;
    }
    .noCoHost {
      margin-top: 15px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      .add-cohost-action {
        cursor: pointer;
        font-size: 16px;
        color: #33ab4f;
        font-weight: bold;
        text-decoration: underline;
        p {
          display: inline-block;
        }
      }
    }
    .loading-txt {
      height: 215px;
      color: rgb(144, 144, 144);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .assignBox {
      margin-top: 15px;
      .checkbox-circle .el-checkbox__input {
        border-radius: 50%;
      }
      .checkbox-circle .el-checkbox__inner {
        border-radius: 50%;
      }
      .el-checkbox__label {
        display: none;
      }
      .el-checkbox__inner:hover {
        border-color: #33ab4f;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #33ab4f;
        border-color: #33ab4f;
      }
      .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #33ab4f;
      }
      .userListBox {
        display: flex;
        align-items: center;
        padding: 7px 15px 7px 0px;
        .el-icon-user-solid {
          font-size: 23px;
        }
        .el-icon-search {
          cursor: pointer;
          font-size: 18px;
          margin-right: 28px;
        }
        .title{
          margin-right: 28px;
          width: 100%;
          font-size: 16px;
        }
        .title, .el-input {
          margin-right: 28px;
        }
        .el-input__inner {
          border: none;
          color: #33ab4f;
          font-size: 16px;
          border-radius: 6px;
        }
        .el-button {
          width: 85px;
          height: 36px;
          border-color: #33ab4f;
          background: #33ab4f;
          color: #fff;
          border-radius: 4px;
          &:hover {
            background: #0aa20a;
          }
        }
        .emailWarn {
          margin-top: 8px;
        }
        .setEmailBox {
          padding-left: 34px;
          margin-top: 8px;
          .el-checkbox__input {
            .el-checkbox__inner {
              width: 18px;
              height: 18px;
              &::after {
                height: 11px;
                left: 6px;
              }
              &:hover {
                border-color: #dcdfe6;
              }
            }
            &.is-checked {
              .el-checkbox__inner {
                background: #0aa20a;
                border-color: #0aa20a;
              }
              & + .el-checkbox__label {
                color: gray;
              }
            }
          }
        }
      }
      .hadInviteList {
        margin-top: 15px;
        &::-webkit-scrollbar-thumb {
          background-color: #ccc;
          border-radius: 10px;
        }
        overflow-y: auto;
        height: 215px;
        .el-divider {
          background: #f5f5f5;
          &.el-divider--horizontal {
            margin: 7px 0;
          }
        }
        .li {
          cursor: pointer;
          margin-bottom: 10px;
          overflow: hidden;
          line-height: 32px;
          padding: 7px 15px 7px 15px;
          border-radius: 10px;
          &:hover {
            background: #f8f9fa;
            .el-icon-more {
              display: inline-block;
            }
          }
          .firstName {
            width: 32px;
            height: 32px;
            background: orange;
            border-radius: 50%;
            display: inline-block;
            text-align: center;
            line-height: 32px;
            font-size: 17px;
            margin-right: 14px;
            color: #fff;
          }
          .emailContent {
            font-size: 17px;
            display: inline-block;
            &.declined {
              text-decoration: line-through;
            }
          }
          .el-icon-more {
            display: none;
            margin-top: 9px;
          }
        }
      }
      .selectedBox{
        text-align: right;
      }
    }
    .el-input {
      &.redBorder {
        border: 1px solid red;
        border-radius: 3px;

        .el-input__inner {
          border: none;
        }
      }

      .el-input__inner {
        background: #f2f1f1fa;
        border-radius: 4px 4px 0 0;
        height: 40px;
        line-height: 40px;
      }
    }
    .el-tabs__active-bar {
      background: #33ab4f;
    }
    .el-tabs__item {
      font-size: 20px;

      &.is-active {
        color: #33ab4f;
      }

      &:hover {
        color: #33ab4f;
      }
    }
    .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
      border-bottom: 1px solid #ebeef5 !important;
    }
    .el-table::before {
      background: none;
    }
  }
  .el-dialog__footer {
    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .cancel {
      margin-right: 40px;
      border: none !important;
      background: none !important;
      color: #6d6d6d !important;
    }
    .el-button {
      width: 85px;
      height: 36px;
      border-color: #33ab4f;
      background: #33ab4f;
      color: #fff;
      border-radius: 4px;
      &:hover {
        background: #0aa20a;
      }
    }
    .enterReceivedCohost {
      cursor: pointer;
      font-size: 16px;
      color: #33ab4f;
      .el-icon-plus{
        font-size: 10px;
        font-weight: bold;
        margin-right: 3px;
      }
      p {
        display: inline-block;
      }
    }
  }
}
</style>
